
import { Vue, Component, Prop } from "vue-property-decorator";

import GET_CONTRACTOR_RATINGS from "@/apollo/contractors/GetContractorRatings.gql";

import ContractorReview from "@/components/companyContractors/ContractorReviewNew.vue";
import PlusIcon from "@/components/icons/PlusIcon.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholder.vue";
import UIButton from "@/components/button/ui-button.vue";
import ReviewModal from "@/components/rating/ReviewModal.vue";
import CardPagination from "@/components/card/CardPagination.vue";

import {
  Contractor_Rating,
  User,
  Contractor_Rating_Bool_Exp,
} from "@/generated/graphql";
import PaginationConfig from "@/entities/PaginationConfig";
import paginationConfig from "@/data/paginationConfig";
import ActionsPanel from "@/components/common/ActionsPanel.vue";
import RouteParams from "@/entities/RouteParams";
import RouteNames from "@/entities/RouteNames";
import CardBodyItem from "@/components/card/CardBodyItemNew.vue";
import ReviewDetails from "@/components/reviews/ReviewDetailsNew.vue";
import EmptyListImageReviews from "@/components/icons/emptyListImages/EmptyListImageReviews.vue";

interface RatingQueryVariables {
  limit: number;
  offset: number;
  contractorId: string;
  currentUserId: string;
}

@Component({
  components: {
    EmptyListImageReviews,
    ActionsPanel,
    ReviewDetails,
    ContractorReview,
    UIButton,
    PlusIcon,
    EmptyListPlaceholder,
    LoadingOverlay,
    ReviewModal,
    CardPagination,
    CardBodyItem,
  },
  apollo: {
    ratings: {
      query: GET_CONTRACTOR_RATINGS,
      variables() {
        return this.ratingQueryVariables;
      },
      update(data) {
        this.paginationConfig.loadedCount = data.contractorRatings.length;
        this.paginationConfig.total = data.ratingTotal.aggregate.count;
        this.myReview = data.myReview[0];
        return data.contractorRatings;
      },
    },
  },
})
export default class ReviewSidebar extends Vue {
  @Prop({ type: String, required: true }) readonly contractorId!: string;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: String, required: true }) readonly currentUserRole!: string;
  @Prop({ type: String, required: true }) readonly contractorFullName!: string;

  ratings?: Contractor_Rating[] = undefined;
  myReview: Contractor_Rating | null = null;
  paginationConfig: PaginationConfig = { ...paginationConfig };
  dialog: boolean = false;

  get ratingQueryVariables(): RatingQueryVariables {
    const { page, limit } = this.paginationConfig;
    const nextOffset = page * limit - limit;

    return {
      offset: nextOffset,
      limit: limit,
      contractorId: this.contractorId,
      currentUserId: this.currentUserId,
    };
  }

  get isDataLoaded(): boolean {
    return Boolean(this.ratings?.length);
  }

  get showEmptyListPlaceholder(): boolean {
    return !Boolean(this.reviewsCollection);
  }

  get emptyListTitle(): string {
    return ``;
  }

  get emptyListSubtitle(): string {
    return `Start adding reveiws to ${this.contractorFullName}`;
  }

  get reviewsCollection(): Contractor_Rating[] | undefined {
    if (!this.ratings || !this.ratings.length) {
      return undefined;
    }

    if (!this.myReview) {
      return this.ratings;
    }

    return this.ratings.filter(({ id }) => id !== this.myReview!.id);
  }

  getActivitiesRouteParams(projectId: string): RouteParams<{ id: string }> {
    return {
      name: RouteNames.PROJECT_ACTIVITY,
      params: {
        id: projectId,
      },
    };
  }

  toggleReviewModal(): void {
    this.dialog = !this.dialog;
  }

  refetchReviews(): void {
    this.$apollo.queries.ratings.refetch();
  }
}
